import { Empty, Spin } from 'antd'
import React from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'

import { useGetPostListQuery } from '@/generated/graphql'
import { PostCard } from '@/modules/post/post-card'

import s from './post-list.module.less'

export const PostList: React.FC<{ type: 'favor' | 'liked' | 'commented' | 'useful' }> = ({ type }) => {
  const last = 8
  const { data, fetchMore, loading } = useGetPostListQuery({
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first',
    variables: {
      pagination: {
        last,
      },
      ...(type === 'favor' && { withFavoredPosts: true }),
      ...(type === 'liked' && { withLikedPosts: true }),
      ...(type === 'useful' && { withUsefulPosts: true }),
      ...(type === 'commented' && {
        withCommentedPosts: true,
        parentCommentPagination: { last: 2 },
        childCommentPagination: { last: 2 },
      }),
    },
    notifyOnNetworkStatusChange: true,
  })

  const { posts, pageInfo } = (() => {
    if (!data) {
      return {
        titleString: '',
        posts: [],
        pageInfo: {
          startCursor: null,
          endCursor: null,
          hasNextPage: null,
          hasPreviousPage: null,
        },
      }
    }

    switch (type) {
      case 'favor':
        return {
          posts: data.viewer.favoredPosts!.edges.slice().reverse(),
          pageInfo: data.viewer.favoredPosts!.pageInfo,
        }
      case 'liked':
        return { posts: data.viewer.likedPosts!.edges.slice().reverse(), pageInfo: data.viewer.likedPosts!.pageInfo }
      case 'useful':
        return {
          posts: data.viewer.userfulPosts!.edges.slice().reverse(),
          pageInfo: data.viewer.userfulPosts!.pageInfo,
        }
      case 'commented':
        return {
          posts: data.viewer.commentedPosts!.edges.slice().reverse(),
          pageInfo: data.viewer.commentedPosts!.pageInfo,
        }
    }
  })()

  const loadingComponent = loading && (
    <div className={s.loading}>
      <Spin delay={300} size='large' />
    </div>
  )

  const empty = (
    <div className={s.postList}>
      <Empty />
    </div>
  )

  return (
    <div className={s.container}>
      <InfiniteScroll
        dataLength={posts.filter((post) => post).length}
        className={s.postList}
        loader={loadingComponent}
        hasMore={!!pageInfo.hasPreviousPage}
        next={() => {
          fetchMore({
            variables: {
              pagination: {
                last,
                before: pageInfo.startCursor,
              },
            },
          })
        }}
      >
        {posts.length === 0
          ? empty
          : posts
              .filter((post) => post) // Typescript Error: This expression is not callable
              .map(({ node: p }) => <PostCard key={p.postId} post={p} />)}
      </InfiniteScroll>
    </div>
  )
}
